module.exports = __webpack_public_path__ + "catalog/items/bedroom/Single-Bed/Single-Bed.svg";